import * as React from "react";
import { cn } from "@/lib/utils";

const ButtonGroup = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "inline-flex rounded-lg overflow-hidden border border-input",
      "[&>button:not(:last-child)]:rounded-none [&>button:not(:last-child)]:border-r [&>button:not(:last-child)]:border-r-input",
      "[&>button:not(:first-child)]:rounded-none",
      "[&>button:first-child]:rounded-l-lg [&>button:first-child]:rounded-r-none [&>button:first-child]:border-0",
      "[&>button:last-child]:rounded-r-lg [&>button:last-child]:rounded-l-none [&>button:last-child]:border-0",
      "[&>button]:border-0",
      className
    )}
    {...props}
  />
));
ButtonGroup.displayName = "ButtonGroup";

export { ButtonGroup };
